const user = {
  deletedSuccessfully: 'User deleted successfully.',
  blockSuccessfully: 'User block successfully.',
  updatedSuccessfully: 'User updated successfully.',
  createdSuccessfully: 'User created successfully.',
  unBlockSuccessfully: 'User unblock successfully.',
  notFound: 'User not found.',
  noIdProvided: 'No user id provided!',
} as const;

export default user;
